/**
 * Quick Shop sheet for collection product cards.
 * Mobile: bottom sheet. Desktop: slides in from the right.
 */
(function () {
  'use strict';

  var root = document.getElementById('quick-shop');
  if (!root) return;

  var titleEl = root.querySelector('.quick-shop__title');
  var priceEl = root.querySelector('.quick-shop__price');
  var thumbEl = root.querySelector('.quick-shop__thumb');
  var ratingEl = root.querySelector('[data-quick-shop-rating]');
  var ratingTextEl = root.querySelector('[data-quick-shop-rating-text]');
  var starsFillEl = root.querySelector('[data-quick-shop-stars-fill]');
  var lengthWrap = root.querySelector('[data-quick-shop-length]');
  var chipsEl = root.querySelector('[data-quick-shop-chips]');
  var qtyLabelEl = root.querySelector('[data-quick-shop-qty-label]');
  var qtyHintEl = root.querySelector('[data-quick-shop-qty-hint]');
  var packsEl = root.querySelector('[data-quick-shop-packs]');
  var stepperEl = root.querySelector('[data-quick-shop-stepper]');
  var qtyInput = root.querySelector('[data-quick-shop-qty-input]');
  var closureWrap = root.querySelector('[data-quick-shop-closure]');
  var closureToggle = root.querySelector('[data-quick-shop-closure-toggle]');
  var closureCheckLabel = root.querySelector('[data-quick-shop-closure-check-label]');
  var closureSelectWrap = root.querySelector('[data-quick-shop-closure-select-wrap]');
  var closureSelect = root.querySelector('[data-quick-shop-closure-select]');
  var stockEl = root.querySelector('[data-quick-shop-stock]');
  var atcBtn = root.querySelector('[data-quick-shop-atc]');
  var pdpLink = root.querySelector('[data-quick-shop-pdp]');
  var totalEl = root.querySelector('[data-quick-shop-total]');
  var lowStockEl = root.querySelector('[data-quick-shop-low-stock]');
  var guideRoot = root.querySelector('[data-quick-shop-guide]');
  var lastFocus = null;
  var hydrateSeq = 0;

  var state = {
    product: null,
    selectedLength: null,
    variantId: null,
    variantPrice: null,
    variantCompareAt: null,
    maxQty: null,
    packMode: '3',
    closureEnabled: false,
    closureVariantId: null,
    closurePrice: 0
  };

  function stripMoneyHtml(value) {
    if (!value) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = String(value);
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) return '—';
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return stripMoneyHtml(theme.Currency.formatMoney(cents, theme.moneyFormat));
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return stripMoneyHtml(Shopify.formatMoney(cents, (theme && theme.moneyFormat) || '${{amount}}'));
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function rememberCompareAt(variantId, compareAt) {
    if (!window.theme) window.theme = {};
    if (!theme.variantCompareAt) theme.variantCompareAt = {};
    if (variantId == null) return;
    if (compareAt != null && compareAt > 0) {
      theme.variantCompareAt[variantId] = compareAt;
      theme.variantCompareAt[String(variantId)] = compareAt;
    }
  }

  function registerProductCompareAt(product) {
    if (!product) return;
    (product.variants || []).forEach(function (v) {
      rememberCompareAt(v.id, v.compare_at_price);
    });
  }

  function setPriceDisplay(priceCents, compareAtCents, fromPrefix) {
    if (!priceEl) return;
    if (priceCents === null || priceCents === undefined || isNaN(priceCents)) {
      priceEl.textContent = '';
      return;
    }

    if (compareAtCents && compareAtCents > priceCents) {
      priceEl.innerHTML =
        (fromPrefix ? '<span class="product-price__from">From </span>' : '') +
        '<s class="product-price__price product-price__compare">' + formatMoney(compareAtCents) + '</s> ' +
        '<span class="product-price__price product-price__sale">' + formatMoney(priceCents) + '</span>';
    } else {
      priceEl.textContent = (fromPrefix ? 'From ' : '') + formatMoney(priceCents);
    }
  }

  function updateHeaderPrice() {
    var product = state.product;
    if (!product) {
      setPriceDisplay(null, null, false);
      return;
    }

    if (state.selectedLength) {
      var variant = findVariant(product, state.selectedLength);
      if (variant) {
        setPriceDisplay(variant.price, variant.compare_at_price, false);
        return;
      }
    }

    setPriceDisplay(product.price, product.compare_at_price, true);
  }

  function parseCardData(button) {
    var card = button.closest('.product-card');
    if (!card) return null;
    var script = card.querySelector('.product-card__data');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Collection card JSON often truncates product.variants (observed 10 → 5),
   * same class of issue as PDP ProductJson. Fetch the full product.js payload
   * and merge variants while keeping card-only fields (bundle flag, ratings,
   * matching_closure, cropped title/image).
   */
  function mapAjaxVariant(v, existing) {
    existing = existing || {};
    return {
      id: v.id,
      title: v.title,
      option1: v.option1,
      option2: v.option2,
      option3: v.option3,
      available: v.available,
      price: v.price,
      compare_at_price: v.compare_at_price,
      // product.js omits inventory_quantity — keep Liquid values when present
      inventory_quantity:
        existing.inventory_quantity != null ? existing.inventory_quantity : v.inventory_quantity,
      inventory_management:
        existing.inventory_management != null
          ? existing.inventory_management
          : v.inventory_management != null
            ? v.inventory_management
            : null,
      inventory_policy:
        existing.inventory_policy != null
          ? existing.inventory_policy
          : v.inventory_policy != null
            ? v.inventory_policy
            : null
    };
  }

  function mergeAjaxVariants(product, full) {
    if (!product || !full || !full.variants || !full.variants.length) return product;
    var currentCount = (product.variants || []).length;
    if (full.variants.length < currentCount) return product;

    var byId = {};
    (product.variants || []).forEach(function (v) {
      if (v && v.id != null) byId[v.id] = v;
    });

    product.variants = full.variants.map(function (v) {
      return mapAjaxVariant(v, byId[v.id]);
    });

    if (full.price != null) product.price = full.price;
    if (full.compare_at_price != null) product.compare_at_price = full.compare_at_price;
    if (typeof full.available === 'boolean') product.available = full.available;

    return product;
  }

  function patchCardVariants(handle, variants) {
    if (!handle || !variants || !variants.length) return;
    document.querySelectorAll('.product-card__data').forEach(function (script) {
      try {
        var data = JSON.parse(script.textContent);
        if (data.handle !== handle) return;
        if ((data.variants || []).length >= variants.length) return;
        data.variants = variants;
        script.textContent = JSON.stringify(data);
      } catch (e) { /* ignore */ }
    });
  }

  function hydrateProductVariants(product) {
    if (!product || !product.handle) return Promise.resolve(product);

    return fetch('/products/' + encodeURIComponent(product.handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Quick Shop hydrate failed');
        return res.json();
      })
      .then(function (full) {
        var merged = mergeAjaxVariants(product, full);
        patchCardVariants(merged.handle, merged.variants);
        return merged;
      })
      .catch(function () {
        return product;
      });
  }

  function applyHydratedProduct(product, selectedLength) {
    state.product = product;
    registerProductCompareAt(product);
    renderLengthChips(product);

    if (selectedLength) {
      var stillExists = getLengthValues(product).indexOf(selectedLength) !== -1;
      if (stillExists) {
        state.selectedLength = selectedLength;
        Array.prototype.forEach.call(chipsEl.querySelectorAll('.quick-shop__chip'), function (chip) {
          chip.classList.toggle(
            'is-selected',
            chip.getAttribute('data-length') === selectedLength
          );
        });
      } else {
        state.selectedLength = null;
      }
    }

    syncPackUI();
    rebuildClosureOptions(true);
    updateHeaderPrice();
    updateAtc();
  }

  function parseLengthInches(value) {
    if (!value) return null;
    var match = String(value).match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function getLengthValues(product) {
    var idx = product.length_option_index;
    if (idx === null || idx === undefined) return [];
    var values = [];
    var seen = {};
    (product.variants || []).forEach(function (v) {
      var key = 'option' + (idx + 1);
      var val = v[key];
      if (val && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    });
    return values;
  }

  function findVariant(product, lengthValue) {
    var idx = product.length_option_index;
    if (idx === null || idx === undefined) {
      return (product.variants || []).filter(function (v) { return v.available; })[0] ||
        (product.variants || [])[0] ||
        null;
    }
    var key = 'option' + (idx + 1);
    var match = (product.variants || []).filter(function (v) {
      return v[key] === lengthValue;
    });
    var available = match.filter(function (v) { return v.available; });
    return available[0] || match[0] || null;
  }

  function findClosestClosureVariant(closure, targetLength) {
    if (!closure || !closure.variants || !closure.variants.length) return null;

    var idx = closure.length_option_index;
    var available = closure.variants.filter(function (v) { return v.available; });
    var pool = available.length ? available : closure.variants;

    if (idx === null || idx === undefined) {
      return pool[0] || null;
    }

    var key = 'option' + (idx + 1);
    var targetInches = parseLengthInches(targetLength);

    var exact = pool.filter(function (v) { return v[key] === targetLength; })[0];
    if (exact) return exact;

    if (targetInches == null) return pool[0] || null;

    var best = null;
    var bestDiff = Infinity;
    pool.forEach(function (v) {
      var inches = parseLengthInches(v[key]);
      if (inches == null) return;
      var diff = Math.abs(inches - targetInches);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = v;
      }
    });
    return best || pool[0] || null;
  }

  function getQty() {
    var qty = parseInt(qtyInput.value, 10);
    if (isNaN(qty) || qty < 1) return 1;
    if (state.maxQty != null && qty > state.maxQty) {
      qtyInput.value = String(state.maxQty);
      return state.maxQty;
    }
    return qty;
  }

  function isBundleProduct(product) {
    return !!(product && product.is_bundle);
  }

  function updateRating(product) {
    if (!ratingEl || !ratingTextEl) return;
    var avg = product && product.rating_average != null ? Number(product.rating_average) : null;
    var count = product && product.rating_count != null ? Number(product.rating_count) : null;

    if (!avg || !count || isNaN(avg) || isNaN(count) || count < 1) {
      ratingEl.hidden = true;
      ratingTextEl.textContent = '';
      ratingEl.removeAttribute('aria-label');
      if (starsFillEl) starsFillEl.style.width = '0%';
      return;
    }

    var clamped = Math.max(0, Math.min(5, avg));
    var pct = Math.round((clamped / 5) * 1000) / 10;

    ratingEl.hidden = false;
    ratingEl.setAttribute('aria-label', clamped.toFixed(1) + ' out of 5 stars, ' + count + ' reviews');
    ratingTextEl.textContent = avg.toFixed(1) + ' (' + count.toLocaleString() + ' reviews)';
    if (starsFillEl) starsFillEl.style.width = pct + '%';
  }

  function updateLowStock(variant) {
    var lowStock = (window.theme && theme.lowStock) || {};
    var threshold = Number(lowStock.threshold) || 5;
    var inv = variant && variant.inventory_quantity;
    var managed = variant && variant.inventory_management === 'shopify';
    var policyDeny = !variant || variant.inventory_policy !== 'continue';
    var isLow =
      lowStock.enabled !== false &&
      managed &&
      policyDeny &&
      inv > 0 &&
      inv < threshold;

    if (lowStockEl) {
      if (isLow) {
        lowStockEl.hidden = false;
        lowStockEl.textContent = 'Hurry! Only ' + inv + ' left in stock.';
        state.maxQty = inv;
        qtyInput.max = String(inv);
        if (getQty() > inv) qtyInput.value = String(inv);
      } else {
        lowStockEl.hidden = true;
        lowStockEl.textContent = '';
        state.maxQty = null;
        qtyInput.removeAttribute('max');
      }
    } else {
      state.maxQty = null;
    }

    // In-stock message: show when a selected variant is available and not in low-stock mode
    if (stockEl) {
      if (variant && variant.available && !isLow) {
        stockEl.hidden = false;
      } else {
        stockEl.hidden = true;
      }
    }
  }

  function updatePackPrices() {
    if (!packsEl || !state.variantPrice) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pack-price]'), function (el) {
        el.textContent = '';
      });
      return;
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-pack-price]'), function (el) {
      var qty = parseInt(el.getAttribute('data-pack-price'), 10);
      el.textContent = formatMoney(state.variantPrice * qty);
    });
  }

  function syncPackUI() {
    var bundle = isBundleProduct(state.product);
    if (!packsEl || !stepperEl) return;

    if (!bundle) {
      packsEl.hidden = true;
      stepperEl.hidden = false;
      if (qtyHintEl) qtyHintEl.hidden = true;
      if (qtyLabelEl) qtyLabelEl.textContent = '2. Choose quantity';
      return;
    }

    packsEl.hidden = false;
    if (qtyHintEl) qtyHintEl.hidden = false;
    if (qtyLabelEl) qtyLabelEl.textContent = '2. Choose bundle quantity';

    Array.prototype.forEach.call(packsEl.querySelectorAll('[data-quick-shop-pack]'), function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-quick-shop-pack') === state.packMode);
    });

    stepperEl.hidden = state.packMode !== 'other';
  }

  function setPackMode(mode) {
    state.packMode = mode;
    if (mode === '2' || mode === '3') {
      qtyInput.value = mode;
    } else if (mode === 'other') {
      var current = parseInt(qtyInput.value, 10);
      if (current === 2 || current === 3 || isNaN(current) || current < 1) {
        qtyInput.value = '1';
      }
    }
    syncPackUI();
    updateAtc();
  }

  function getClosureLabel(variant, closure) {
    if (!variant) return closure.title || 'Closure';
    if (variant.title && variant.title !== 'Default Title') {
      return variant.title + ' — ' + formatMoney(variant.price);
    }
    return (closure.title || 'Closure') + ' — ' + formatMoney(variant.price);
  }

  function getClosurePool(closure) {
    if (!closure || !closure.variants) return [];
    var available = closure.variants.filter(function (v) { return v.available; });
    return available.length ? available : closure.variants;
  }

  function rebuildClosureOptions(preferMatch) {
    if (!closureWrap || !closureSelect) return;

    var closure = state.product && state.product.matching_closure;
    if (!closure || !closure.variants || !closure.variants.length) {
      closureWrap.hidden = true;
      state.closureEnabled = false;
      state.closureVariantId = null;
      state.closurePrice = 0;
      if (closureToggle) closureToggle.checked = false;
      if (closureSelectWrap) closureSelectWrap.hidden = true;
      return;
    }

    closureWrap.hidden = false;
    var pool = getClosurePool(closure);
    var matched = findClosestClosureVariant(closure, state.selectedLength);
    var selectedId = preferMatch && matched
      ? matched.id
      : (parseInt(closureSelect.value, 10) || (matched && matched.id) || (pool[0] && pool[0].id));

    var optionsHtml = '';
    pool.forEach(function (v) {
      optionsHtml +=
        '<option value="' + v.id + '"' +
        (selectedId === v.id ? ' selected' : '') +
        '>' + getClosureLabel(v, closure) + '</option>';
    });
    closureSelect.innerHTML = optionsHtml;
    syncClosureSelection();
  }

  function syncClosureSelection() {
    if (!closureWrap || !closureSelect) return;

    var closure = state.product && state.product.matching_closure;
    if (!closure) {
      state.closureVariantId = null;
      state.closurePrice = 0;
      return;
    }

    var pool = getClosurePool(closure);
    var matched = findClosestClosureVariant(closure, state.selectedLength);
    var selectedId = parseInt(closureSelect.value, 10);
    var selected = pool.filter(function (v) { return v.id === selectedId; })[0] || matched || pool[0];
    var labelVariant = selected || matched || pool[0];
    var basePrice = labelVariant ? labelVariant.price : closure.price || 0;

    if (closureCheckLabel) {
      closureCheckLabel.textContent = 'Add Closure + ' + formatMoney(basePrice);
    }

    if (state.closureEnabled) {
      if (closureSelectWrap) closureSelectWrap.hidden = false;
      state.closureVariantId = selected ? selected.id : null;
      state.closurePrice = selected ? selected.price : 0;
    } else {
      if (closureSelectWrap) closureSelectWrap.hidden = true;
      state.closureVariantId = null;
      state.closurePrice = 0;
    }
  }

  function updateTotal() {
    if (!totalEl) return;
    if (state.variantPrice === null || state.variantPrice === undefined) {
      totalEl.textContent = '—';
      return;
    }
    var total = state.variantPrice * getQty();
    if (state.closureEnabled && state.closurePrice) {
      total += state.closurePrice;
    }
    totalEl.textContent = formatMoney(total);
  }

  function updateAtc() {
    var product = state.product;
    if (!product) {
      atcBtn.disabled = true;
      state.variantPrice = null;
      state.variantCompareAt = null;
      updatePackPrices();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    var lengths = getLengthValues(product);
    var needsLength = lengths.length > 0;

    if (needsLength && !state.selectedLength) {
      state.variantId = null;
      state.variantPrice = null;
      state.variantCompareAt = null;
      state.maxQty = null;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Choose a length';
      updateLowStock(null);
      updatePackPrices();
      syncClosureSelection();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    var variant = findVariant(product, state.selectedLength);
    state.variantId = variant ? variant.id : null;
    state.variantPrice = variant ? variant.price : null;
    state.variantCompareAt = variant ? variant.compare_at_price : null;

    if (!variant || !variant.available) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Sold out';
      updateLowStock(null);
      updatePackPrices();
      syncClosureSelection();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    atcBtn.disabled = false;
    atcBtn.textContent = 'Add to cart';
    updateLowStock(variant);
    updatePackPrices();
    syncClosureSelection();
    updateHeaderPrice();
    updateTotal();
  }

  function renderLengthChips(product) {
    var lengths = getLengthValues(product);
    chipsEl.innerHTML = '';

    if (!lengths.length) {
      lengthWrap.hidden = true;
      state.selectedLength = null;
      return;
    }

    lengthWrap.hidden = false;
    lengths.forEach(function (value) {
      var variant = findVariant(product, value);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quick-shop__chip';
      btn.textContent = value;
      btn.setAttribute('data-length', value);
      if (!variant || !variant.available) {
        btn.classList.add('is-unavailable');
        btn.disabled = true;
      }
      btn.addEventListener('click', function () {
        state.selectedLength = value;
        Array.prototype.forEach.call(chipsEl.querySelectorAll('.quick-shop__chip'), function (chip) {
          chip.classList.toggle('is-selected', chip.getAttribute('data-length') === value);
        });
        rebuildClosureOptions(true);
        updateAtc();
      });
      chipsEl.appendChild(btn);
    });
  }

  function openGuide() {
    if (!guideRoot) return;
    guideRoot.hidden = false;
    guideRoot.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      guideRoot.classList.add('is-open');
    });
  }

  function closeGuide() {
    if (!guideRoot) return;
    guideRoot.classList.remove('is-open');
    guideRoot.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      guideRoot.hidden = true;
    }, 220);
  }

  function open(product) {
    var openToken = ++hydrateSeq;

    state.product = product;
    state.selectedLength = null;
    state.variantId = null;
    state.variantPrice = null;
    state.variantCompareAt = null;
    state.maxQty = null;
    state.packMode = isBundleProduct(product) ? '3' : 'other';
    state.closureEnabled = false;
    state.closureVariantId = null;
    state.closurePrice = 0;

    registerProductCompareAt(product);

    if (lowStockEl) {
      lowStockEl.hidden = true;
      lowStockEl.textContent = '';
    }
    if (stockEl) stockEl.hidden = true;
    if (closureToggle) closureToggle.checked = false;
    if (closureSelectWrap) closureSelectWrap.hidden = true;

    qtyInput.value = isBundleProduct(product) ? '3' : '1';
    qtyInput.removeAttribute('max');

    titleEl.textContent = product.title || '';
    updateHeaderPrice();
    updateRating(product);

    if (pdpLink) {
      pdpLink.href = product.url || (product.handle ? '/products/' + product.handle : '/collections/all');
    }

    if (product.featured_image) {
      thumbEl.src = product.featured_image;
      thumbEl.alt = product.title || '';
      thumbEl.hidden = false;
    } else {
      thumbEl.removeAttribute('src');
      thumbEl.hidden = true;
    }

    renderLengthChips(product);
    syncPackUI();
    rebuildClosureOptions(true);

    if (!getLengthValues(product).length) {
      updateAtc();
    } else {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Choose a length';
      updatePackPrices();
      syncClosureSelection();
      updateTotal();
    }

    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quick-shop-open');

    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });

    // Restore full variant list when collection card JSON was truncated
    var cardVariantCount = (product.variants || []).length;
    hydrateProductVariants(product).then(function (hydrated) {
      if (openToken !== hydrateSeq) return;
      if (!state.product || state.product.handle !== hydrated.handle) return;
      if ((hydrated.variants || []).length <= cardVariantCount) return;
      applyHydratedProduct(hydrated, state.selectedLength);
    });
  }

  function close() {
    closeGuide();
    hydrateSeq += 1;
    root.classList.remove('is-open');
    document.body.classList.remove('quick-shop-open');
    root.setAttribute('aria-hidden', 'true');

    window.setTimeout(function () {
      root.hidden = true;
      state.product = null;
      state.selectedLength = null;
      state.variantId = null;
      state.variantPrice = null;
      state.maxQty = null;
      state.closureEnabled = false;
      state.closureVariantId = null;
      state.closurePrice = 0;
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }, 280);
  }

  function showSuccess(data, qty) {
    if (window.theme && theme.CartDrawer && theme.CartDrawer.isEnabled) {
      theme.CartDrawer.showAdded(data, qty);
      return;
    }
    var successDrawer = document.getElementById('successDrawer');
    if (successDrawer) {
      var pimg = data.image || '';
      var pimgPath = pimg.replace(/(\.[^\.]*$|$)/, '_small' + '$&');
      var imgEl = successDrawer.querySelector('.modal-prod-img');
      var nameEl = successDrawer.querySelector('.modal-prod-name');
      if (imgEl) imgEl.setAttribute('src', pimgPath);
      if (nameEl) nameEl.textContent = data.product_title;
      document.body.classList.add('loading', 'showOverly');
      $(successDrawer).fadeIn(500);
      window.setTimeout(function () {
        document.body.classList.remove('loading', 'showOverly');
        $(successDrawer).fadeOut(200);
      }, 8000);
    }
  }

  function showError(errormsg) {
    atcBtn.disabled = false;
    atcBtn.textContent = 'Add to cart';
    if (window.theme && theme.CartDrawer && theme.CartDrawer.isEnabled && theme.CartDrawer.showError) {
      theme.CartDrawer.showError(errormsg);
      return;
    }
    var errorDrawer = document.getElementById('errorDrawer');
    if (errorDrawer) {
      var msgEl = errorDrawer.querySelector('.error-message');
      if (msgEl) msgEl.textContent = errormsg;
      document.body.classList.add('loading', 'showOverly');
      $(errorDrawer).fadeIn(500);
    } else {
      window.alert(errormsg);
    }
  }

  function addClosureThenFinish(mainData, qty) {
    if (!state.closureEnabled || !state.closureVariantId) {
      document.body.classList.remove('loading');
      close();
      showSuccess(mainData, qty);
      return;
    }

    CartJS.addItem(state.closureVariantId, 1, {}, {
      success: function () {
        document.body.classList.remove('loading');
        close();
        showSuccess(mainData, qty);
      },
      error: function (jqXHR) {
        document.body.classList.remove('loading');
        close();
        // Main item was added; still show success, then surface closure error.
        showSuccess(mainData, qty);
        var errormsg = 'Bundle added, but the closure could not be added.';
        try {
          errormsg = JSON.parse(jqXHR.responseText).description || errormsg;
        } catch (e) {}
        window.setTimeout(function () {
          showError(errormsg);
        }, 400);
      }
    });
  }

  function addToCart() {
    if (atcBtn.disabled || !state.variantId) return;

    var qty = getQty();
    if (state.maxQty != null && qty > state.maxQty) {
      qty = state.maxQty;
      qtyInput.value = String(qty);
    }

    if (typeof CartJS === 'undefined' || !theme.ajax_cart) {
      var url = '/cart/add?id=' + state.variantId + '&quantity=' + qty;
      if (state.closureEnabled && state.closureVariantId) {
        // Fall back: add main item only via redirect; closure needs Ajax.
        url = '/cart/add?id=' + state.variantId + '&quantity=' + qty;
      }
      window.location.href = url;
      return;
    }

    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding…';
    document.body.classList.add('loading');

    CartJS.addItem(state.variantId, qty, {}, {
      success: function (data) {
        addClosureThenFinish(data, qty);
      },
      error: function (jqXHR) {
        document.body.classList.remove('loading');
        var errormsg = 'Unable to add to cart';
        try {
          errormsg = JSON.parse(jqXHR.responseText).description;
        } catch (e) {}
        showError(errormsg);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-shop]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var product = parseCardData(trigger);
      if (product) open(product);
      return;
    }

    if (e.target.closest('[data-quick-shop-guide-close]')) {
      e.preventDefault();
      closeGuide();
      return;
    }

    if (e.target.closest('[data-quick-shop-length-guide]')) {
      e.preventDefault();
      openGuide();
      return;
    }

    if (e.target.closest('[data-quick-shop-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var packBtn = e.target.closest('[data-quick-shop-pack]');
    if (packBtn && root.contains(packBtn)) {
      e.preventDefault();
      setPackMode(packBtn.getAttribute('data-quick-shop-pack'));
      return;
    }

    var qtyBtn = e.target.closest('[data-quick-shop-qty]');
    if (qtyBtn && root.contains(qtyBtn)) {
      e.preventDefault();
      var current = getQty();
      if (qtyBtn.getAttribute('data-quick-shop-qty') === 'plus') {
        var next = current + 1;
        if (state.maxQty != null && next > state.maxQty) next = state.maxQty;
        qtyInput.value = String(next);
      } else if (current > 1) {
        qtyInput.value = String(current - 1);
      }
      updateTotal();
      return;
    }

    if (e.target.closest('[data-quick-shop-atc]')) {
      e.preventDefault();
      addToCart();
    }
  });

  if (closureToggle) {
    closureToggle.addEventListener('change', function () {
      state.closureEnabled = !!closureToggle.checked;
      syncClosureSelection();
      updateTotal();
    });
  }

  if (closureSelect) {
    closureSelect.addEventListener('change', function () {
      syncClosureSelection();
      updateTotal();
    });
  }

  qtyInput.addEventListener('input', function () {
    if (isBundleProduct(state.product) && state.packMode !== 'other') {
      state.packMode = 'other';
      syncPackUI();
    }
    updateTotal();
  });

  if (pdpLink) {
    pdpLink.addEventListener('click', function (e) {
      var url = (state.product && state.product.url) ||
        (state.product && state.product.handle ? '/products/' + state.product.handle : null) ||
        pdpLink.getAttribute('href');
      if (!url || url === '#') {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      window.location.assign(url);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (guideRoot && guideRoot.classList.contains('is-open')) {
      closeGuide();
      return;
    }
    if (root.classList.contains('is-open')) {
      close();
    }
  });
})();
